import sendTrackData from '@jushuitan/jst-track';
import { curry } from 'lodash';

type eventIdType = '1001' | '2001' | '2002' | '3001' | '3002' | '4001';
class Logger {
  initParams: { app_key: any; co_id: any; user_id: any; is_track_prod: any };
  /**
   * 初始化埋点日志库
   * @param app_key 应用ID
   * @param co_id 公司ID
   * @param user_id 用户ID
   */
  constructor(
    app_key: string,
    co_id: string,
    user_id: string,
    isProd: boolean = false,
  ) {
    this.initParams = {
      app_key,
      co_id,
      user_id,
      is_track_prod: isProd,
    };
  }

  /**
   * 埋点日志上报方法
   * @param eventId 操作类型
   * (1001=登陆,2001 = 页面进入,2002 = 页面离开,3001 = 控件点击,3002 = 控件曝光,4001 = 大前端用于行为统计)
   * @param element
   * 控件编码
   * 统计控件的点击数。只有当event_id=3001时，该字段才有值
   * @param element_args
   * 控件参数
   * @param isProd
   * 是否是正式环境,只有正式环境才上报,其他环境console.log
   */
  sendLog(
    eventId: eventIdType,
    element: any,
    element_args: any = {},
    extra_args: any = {},
  ) {
    sendTrackData({
      event_id: eventId,
      element,
      element_args: JSON.stringify(element_args),
      ...this.initParams,
      ...extra_args,
    });
  }
}

const getLogger: any = curry(
  (coId: string, userId: string, isProd: boolean) =>
    new Logger('jst-epaas', coId, userId, isProd),
);

export default getLogger;
